import React, { useState, useEffect } from "react";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import Modal from "react-modal";
import Select from "react-select";
import { Switch } from "@blueprintjs/core";

// COMPONENTS
import GiftCreateUpdate from "./GiftCreateUpdate";
import ContainerContent from "../Container/ContainerContent";
import GiftRecommend from "./GiftRecommend";
import GiftCategory from "./GiftCategory";

function GiftMain() {
  const [modalIsOpen, setIsOpen] = useState(false);
  const [modalItem, setModalItem] = useState(null);
  const [tabIndex, setTabIndex] = useState(0);

  function openModal() {
    setIsOpen(true);
  }

  function closeModal() {
    setIsOpen(false);
    setModalItem(null);
  }

  const onTabChange = (index) => {
    setTabIndex(index);
    setModalItem(null);
  };

  return (
    <ContainerContent>
      {modalIsOpen ? (
        <GiftCreateUpdate
          title={modalItem ? `อัพเดตสินค้า ${modalItem?.name}` : "เพิ่มสินค้า"}
          item={modalItem}
          closeModal={closeModal}
        />
      ) : (
        <div>
          <div className="flex flex-row justify-between  m-8 mt-0">
            <div className="text-lg">สินค้าสมนาคุณ Money Hub</div>
            <button
              className="bg-blue-500 p-2 rounded text-white"
              onClick={openModal}
            >
              เพิ่มสินค้า
            </button>
          </div>
          <Tabs value={tabIndex} onSelect={(index) => onTabChange(index)}>
            <TabList>
              <Tab>ยอดนิยม</Tab>
              <Tab>สินค้า Platinum</Tab>
              <Tab>สินค้า Gold</Tab>
              <Tab>สินค้า Premium</Tab>
            </TabList>
            <TabPanel>
              <GiftRecommend
                isEdit={modalIsOpen}
                setIsEdit={setIsOpen}
                modalItem={modalItem}
                setModalItem={setModalItem}
                closeModal={closeModal}
              />
            </TabPanel>
            <TabPanel>
              <GiftCategory
                categoryName="สินค้า Platinum"
                isEdit={modalIsOpen}
                setIsEdit={setIsOpen}
                modalItem={modalItem}
                setModalItem={setModalItem}
                closeModal={closeModal}
              />
            </TabPanel>
            <TabPanel>
              <GiftCategory
                categoryName="สินค้า Gold"
                isEdit={modalIsOpen}
                setIsEdit={setIsOpen}
                modalItem={modalItem}
                setModalItem={setModalItem}
                closeModal={closeModal}
              />
            </TabPanel>
            <TabPanel>
              <GiftCategory
                categoryName="สินค้า Premium"
                isEdit={modalIsOpen}
                setIsEdit={setIsOpen}
                modalItem={modalItem}
                setModalItem={setModalItem}
                closeModal={closeModal}
              />
            </TabPanel>
          </Tabs>
        </div>
      )}
    </ContainerContent>
  );
}

export default GiftMain;
